import React from 'react';
import './Testimonials.css';
import { toSentenceCase } from '../utils/textUtils';

function Testimonials() {
  const testimonials = [
    {
      rating: 5,
      text: 'Avec le GSU Les Palmiers, mon fils est devenu une étoile. La qualité de l\'enseignement ici est vraiment au super bien.',
      initial: 'F',
      name: 'Fatou, 15 ans',
      role: 'Terminale'
    },
    {
      rating: 4,
      text: 'Le GSU Les Palmiers c\'est une école qui nous a permis de grandir même si ça ne pas toujours été facile.',
      initial: 'Y',
      name: 'Yann, 24 ans',
      role: 'Ex-étudiant'
    },
    {
      rating: 5,
      text: 'Mes cours chez le GSU Les Palmiers, c\'est un endroit formidable pour avancer dans votre vie et avancer.',
      initial: 'A',
      name: 'Aicha, 20 ans',
      role: 'Ancienne étudiante'
    }
  ];

  return (
    <section className="testimonials section">
      <div className="container">
        <h2 className="section-title">Ce qu'ils Disent de nous</h2>

        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card">
              <div className="rating">
                {'★'.repeat(testimonial.rating)}
                {'☆'.repeat(5 - testimonial.rating)}
              </div>
              <p className="testimonial-text">"{toSentenceCase(testimonial.text)}"</p>
              <div className="testimonial-author">
                <div className="author-avatar">{testimonial.initial}</div>
                <div className="author-info">
                  <div className="author-name">{testimonial.name}</div>
                  <div className="author-role">{toSentenceCase(testimonial.role)}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="testimonials-nav">
          <button className="nav-btn">←</button>
          <button className="nav-btn">→</button>
        </div>
      </div>
    </section>
  );
}

export default Testimonials;
